import script from "./ServiceTeamsList.vue?vue&type=script&lang=ts&setup=true"
export * from "./ServiceTeamsList.vue?vue&type=script&lang=ts&setup=true"

import "./ServiceTeamsList.vue?vue&type=style&index=0&id=5e287ab5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e287ab5"]])

export default __exports__